

export enum CircleBusinessZoom {
  // https://confluence.lanhanba.com/pages/viewpage.action?pageId=132263641
  // 1128版本添加的汽车城类型的开店区域，围栏非常大，大到了setFitview之后，缩放级别小于14，导致会显示不出来的
  MinZomm = 12,
  // MinZomm = 14,
  MaxZomm = 16
}

export const TargetZoom = 16.5;

export enum MapMarkerType {
  Marker = 'AMap.Marker',
  Overlay = 'AMap.Overlay',
}
